import * as React from 'react'
import { parts } from 'smshelper'
import Button from 'components/Button'
import pluralize from 'pluralize'

export interface IMessagePriceProps {
  recipients: number
  body: string
}

const style = {
  minWidth: '40px',
  maxWidth: '40px',
  padding: '0px',
  marginRight: '10px',
  cursor: 'default',
}

export const MessagePrice = ({ body, recipients }: IMessagePriceProps) => {
  const segments = parts(body)
  const price = Math.round(segments * 10)
  return (
    <Button
      title={`Total cost AUD ${price}c. ${pluralize('recipient', recipients, true)} x ${pluralize(
        'segment',
        segments,
        true
      )} at 10c/segment`}
      ghost
      style={style}
    >
      {recipients * price}c
    </Button>
  )
}



// WEBPACK FOOTER //
// src/features/Messages/MessagePrice/MessagePrice.tsx